import { Injectable } from '@angular/core'
import { LaskutHakuPyynto, LaskutHakuPyyntoLemonator, LaskutHakuVastaus } from '@lemon/core-firebase/model/lasku'
import { LaskuSharedService } from '@lemon/core-firebase/service/lasku/lasku-shared.service'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'
import { AsiakasService } from 'app/_angular/service/asiakas/asiakas.service'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonator.service'
import { LaskuHakuDataSource } from 'app/_jaettu-angular/laskut/haku/lasku-haku.datasource'
import { LemonTranslationService } from 'app/_jaettu-angular/service/lemon-translation.service'
import { TimestampService } from 'app/_jaettu-angular/service/timestamp-service'
import { firstValueFrom } from 'rxjs'

@Injectable()
export class LaskuHakuDataSourceLemonator extends LaskuHakuDataSource {
  constructor(
    private _asiakasService: AsiakasService,
    private _firebaseLemonaid: FirebaseLemonaid,
    currencyService: CurrencyService,
    dateService: DateService,
    laskuSharedService: LaskuSharedService,
    translationService: LemonTranslationService,
    timestampService: TimestampService,
  ) {
    super(currencyService, dateService, laskuSharedService, translationService, timestampService)
  }

  protected async _kutsuHakua(pyynto: LaskutHakuPyynto): Promise<LaskutHakuVastaus> {
    const avainTiedot = await firstValueFrom(this._asiakasService.nykyinenAsiakasAvainObservable)
    const lemonatorPyynto: LaskutHakuPyyntoLemonator = { ...pyynto, asiakasAvain: avainTiedot.avain }
    return this._firebaseLemonaid.functionsCall<LaskutHakuPyyntoLemonator, LaskutHakuVastaus>('laskutEtsiLemonSearchLemonator', lemonatorPyynto, undefined, 'europe-north1')
  }
}
